import { closeCurrentModal } from 'weblite-web-modal-viewer'
import { styled } from '@mui/material/styles'
import { ExclamationMarkIcon } from '@weblite/icons'
import { Typography, useTheme } from '@mui/material'
import { BottomDrawer } from '$common/bottom-drawer'
import { PrimaryButton, RoundedOutlinedButton } from '$common/buttons'
import { t } from '$i18n'

export function InvalidLink({
  isOpen,
  onConfirm,
  onCancel,
}: {
  isOpen: boolean
  onConfirm: () => void | Promise<unknown>
  onCancel: () => Promise<void>
}) {
  const { palette } = useTheme()
  return (
    <BottomDrawer isOpen={isOpen} onClose={closeCurrentModal}>
      <PageContainer>
        <MainContent>
          <MainIconContainer style={{ backgroundColor: palette.error100 }}>
            <ExclamationMarkIcon
              sx={{ width: '64px', height: '64px', color: 'error.main' }}
            />
          </MainIconContainer>
          <Typography variant="h2" color="neutral1000">
            {t('invalidLinkModal.title')}
          </Typography>
          <Typography
            variant="paragraph1"
            color="neutral900"
            textAlign="center"
          >
            {t('invalidLinkModal.description')}
          </Typography>
        </MainContent>
        <ActionWrapper>
          <PrimaryButton
            fullWidth
            variant="contained"
            text={t('invalidLinkModal.confirmText')}
            onClick={onConfirm}
          />
          <RoundedOutlinedButton
            title={t('invalidLinkModal.cancelText')}
            onClick={onCancel}
          />
        </ActionWrapper>
      </PageContainer>
    </BottomDrawer>
  )
}

const ActionWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  margin: 16px 0;
`

const MainContent = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-bottom: 20px;
  gap: 16px;
`

const PageContainer = styled('div')`
  padding: 64px 24px 8px 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  overflow: auto;
  gap: 16px;
`

const MainIconContainer = styled('div')`
  width: 140px;
  height: 140px;
  margin-bottom: 16px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
`
